/// <reference path="../typings/browser.d.ts" />
/// <reference path="../customtypings/angular/angular-cookies.d.ts" />
/// <reference path="../customtypings/jquery/jquery.d.ts" />
/// <reference path="../customtypings/modalservice/modalservice.d.ts" />
/// <reference path="../customtypings/ng-stomp/ng-stomp.d.ts" />
/// <reference path="../customtypings/selectize/selectize.d.ts" />
/// <reference path="../customtypings/timelinejs/timelinejs.d.ts" />
/// <reference path="../customtypings/velocity/velocity.d.ts" />
/// <reference path="../customtypings/angular-google-maps/angular-google-maps.d.ts" />
/// <reference path="../customtypings/projekktor/projekktor.d.ts" />
/// <reference path="../customtypings/angular-clipboard/angular-clipboard.d.ts" />

/// <reference path="common/AltairUtils.ts" />
/// <reference path="common/CommonInterfaces.ts" />
/// <reference path="common/HttpStatusCodes.ts" />
/// <reference path="common/PromiseStatusCodes.ts" />
/// <reference path="common/IpUtils.ts" />
/// <reference path="common/Theme.ts" />
/// <reference path="common/MathUtils.ts" />
/// <reference path="common/Utils.ts" />
/// <reference path="common/ValidationUtils.ts" />

/// <reference path="models/Acl.ts" />
/// <reference path="models/Action.ts" />
/// <reference path="models/Alarm.ts" />
/// <reference path="models/AlarmConfig.ts" />
/// <reference path="models/Block.ts" />
/// <reference path="models/BlockConnections.ts" />
/// <reference path="models/BlocksFilter.ts" />
/// <reference path="models/BlockType.ts" />
/// <reference path="models/Category.ts" />
/// <reference path="models/ClientInfo.ts" />
/// <reference path="models/ComponentOperation.ts" />
/// <reference path="models/ManagementInfo.ts" />
/// <reference path="models/ConnectionRoom.ts" />
/// <reference path="models/ConnectionValidation.ts" />
/// <reference path="models/ConsoleAlarm.ts" />
/// <reference path="models/DeviceCredential.ts" />
/// <reference path="models/DeviceGui.ts" />
/// <reference path="models/DeviceParams.ts" />
/// <reference path="models/FlexEvent.ts" />
/// <reference path="models/FlexSections.ts" />
/// <reference path="models/FlexoSONPacketMap.ts" />
/// <reference path="models/Gateway.ts" />
/// <reference path="models/ConnectionRoomGroup.ts" />
/// <reference path="models/Digicon.ts" />
/// <reference path="models/Kit.ts" />
/// <reference path="models/GeoElement.ts" />
/// <reference path="models/GridMonitor.ts" />
/// <reference path="models/Hal.ts" />
/// <reference path="models/Hotspot.ts" />
/// <reference path="models/Interpolate.ts" />
/// <reference path="models/Bundle.ts" />
/// <reference path="models/Job.ts" />
/// <reference path="models/LevelMaps.ts" />
/// <reference path="models/MappingInfo.ts" />
/// <reference path="models/MatrixRoom.ts" />
/// <reference path="models/MessageTranslation.ts" />
/// <reference path="models/MobileDevice.ts" />
/// <reference path="models/MobileDeviceDashboard.ts" />
/// <reference path="models/Monitor.ts" />
/// <reference path="models/MonitoringRoom.ts" />
/// <reference path="models/MultiBlock.ts" />
/// <reference path="models/MVPAppScannerJob.ts" />
/// <reference path="models/Network.ts" />
/// <reference path="models/NetworkElement.ts" />
/// <reference path="models/NetworkMap.ts" />
/// <reference path="models/NetworkNode.ts" />
/// <reference path="models/NetworkNodeModem.ts" />
/// <reference path="models/NetworkNodeType.ts" />
/// <reference path="models/NodeHealth.ts" />
/// <reference path="models/Pagination.ts" />
/// <reference path="models/Pipe.ts" />
/// <reference path="models/PortScannerJob.ts" />
/// <reference path="models/PortMapping.ts" />
/// <reference path="models/PresetPathsNode.ts" />
/// <reference path="models/Probe.ts" />
/// <reference path="models/Profile.ts" />
/// <reference path="models/RecordingsExports.ts" />
/// <reference path="models/RedundantBlock.ts" />
/// <reference path="models/ServerClientsInfo.ts" />
/// <reference path="models/SIM.ts" />
/// <reference path="models/SimPlan.ts" />
/// <reference path="models/SystemConfig.ts" />
/// <reference path="models/Son.ts" />
/// <reference path="models/SONDNSEntry.ts" />
/// <reference path="models/SpeedTestResult.ts" />
/// <reference path="models/PresetPath.ts" />
/// <reference path="models/PresetPathBlock.ts" />
/// <reference path="models/StreamPipe.ts" />
/// <reference path="models/StreamStatus.ts" />
/// <reference path="models/SupportToolkitTexts.ts" />
/// <reference path="models/Switch.ts" />
/// <reference path="models/ThumbnailRetriever.ts" />
/// <reference path="models/Timezone.ts" />
/// <reference path="models/TopologyElement.ts" />
/// <reference path="models/TrendingInfo.ts" />
/// <reference path="models/TsProbe.ts" />
/// <reference path="models/User.ts" />
/// <reference path="models/UserGroup.ts" />
/// <reference path="models/VideoFeed.ts" />
/// <reference path="models/Vis.ts" />
/// <reference path="models/Vno.ts" />

/// <reference path="controllers/modals/AboutModalController.ts" />
/// <reference path="controllers/modals/AcknowledgeAllModalController.ts" />
/// <reference path="controllers/modals/AcknowledgeModalController.ts" />
/// <reference path="controllers/modals/AclModalController.ts" />
/// <reference path="controllers/modals/UsedBlocksModalController.ts" />
/// <reference path="controllers/modals/RetakeModalController.ts" />
/// <reference path="controllers/modals/MonitorProbeModalController.ts" />
/// <reference path="controllers/modals/MonitorRtspModalController.ts" />
/// <reference path="controllers/modals/RetakeDoneModalController.ts" />
/// <reference path="controllers/modals/AdminGroupModalController.ts" />
/// <reference path="controllers/modals/AdminGroupsListModalController.ts" />
/// <reference path="controllers/modals/AdminVnoModalController.ts" />
/// <reference path="controllers/modals/UserNewEditModalController.ts" />
/// <reference path="controllers/modals/AvatarModalController.ts" />
/// <reference path="controllers/modals/BlocksModalController.ts" />
/// <reference path="controllers/modals/CategoryModalController.ts" />
/// <reference path="controllers/modals/ChangePasswordModalController.ts" />
/// <reference path="controllers/modals/ChooseVnoModalController.ts" />
/// <reference path="controllers/modals/ConfirmModalController.ts" />
/// <reference path="controllers/modals/DualListModalController.ts" />
/// <reference path="controllers/modals/EditTextFieldModalController.ts" />
/// <reference path="controllers/modals/ErrorModalController.ts"/>
/// <reference path="controllers/modals/GatewayModalController.ts" />
/// <reference path="controllers/modals/DigiconModalController.ts" />
/// <reference path="controllers/modals/GenericInfoModalController.ts" />
/// <reference path="controllers/modals/GenericMultipleModalController.ts" />
/// <reference path="controllers/modals/GenericPromptModalController.ts" />
/// <reference path="controllers/modals/GridStreamSelectionModalController.ts" />
/// <reference path="controllers/modals/ConnectionRoomGroupModalController.ts" />
/// <reference path="controllers/modals/HealthChecksModalController.ts" />
/// <reference path="controllers/modals/HotspotModalController.ts" />
/// <reference path="controllers/modals/InfoModalController.ts" />
/// <reference path="controllers/modals/LinkModalController.ts" />
/// <reference path="controllers/modals/MessageTranslationModalController.ts" />
/// <reference path="controllers/modals/ModalController.ts" />
/// <reference path="controllers/modals/MonitorVideoStreamsModalController.ts" />
/// <reference path="controllers/modals/MultiBlockModal.ts" />
/// <reference path="controllers/modals/NatModalController.ts" />
/// <reference path="controllers/modals/NetworkConfigModalController.ts" />
/// <reference path="controllers/modals/NetworkModalController.ts" />
/// <reference path="controllers/modals/NetworkNodeModalController.ts" />
/// <reference path="controllers/modals/PortScannerJobModalController.ts" />
/// <reference path="controllers/modals/ProbeModalController.ts" />
/// <reference path="controllers/modals/RedundantBlocksModalController.ts" />
/// <reference path="controllers/modals/SearchNodeModalController.ts" />
/// <reference path="controllers/modals/SetLocationModalController.ts" />
/// <reference path="controllers/modals/SIMDataModalController.ts" />
/// <reference path="controllers/modals/SIMModalController.ts" />
/// <reference path="controllers/modals/SimPlanModalController.ts" />
/// <reference path="controllers/modals/SONHostnameModalController.ts" />
/// <reference path="controllers/admin/preset-paths/modal/AddPresetPathsModalController.ts" />
/// <reference path="controllers/admin/preset-paths/modal/BulkAddPresetPathsModalController.ts" />
/// <reference path="controllers/admin/preset-paths/modal/PresetPathSettingsModalController.ts" />
/// <reference path="controllers/modals/TakeModalController.ts" />
/// <reference path="controllers/modals/TakeAllModalController.ts" />
/// <reference path="controllers/modals/TsProbeModalController.ts" />
/// <reference path="controllers/modals/TsDualListModalController.ts" />
/// <reference path="controllers/modals/TTFUploadModalController.ts" />
/// <reference path="controllers/modals/UnlockModalController.ts" />
/// <reference path="controllers/modals/UserExistingModalController.ts" />
/// <reference path="controllers/modals/UserNewEditModalController.ts" />
/// <reference path="controllers/modals/VideoPlayerModalController.ts" />
/// <reference path="controllers/modals/JsonModalController.ts" />

/// <reference path="services/AclService.ts" />
/// <reference path="services/AlarmsService.ts" />
/// <reference path="services/BackendConfigService.ts" />
/// <reference path="services/BackendService.ts" />
/// <reference path="services/Base64Service.ts" />
/// <reference path="services/BlockService.ts" />
/// <reference path="services/BlockConnectionNodesService.ts" />
/// <reference path="services/BlockConnectionBlocksService.ts" />
/// <reference path="services/ComponentOperationService.ts" />
/// <reference path="services/ConnectionRoomService.ts" />
/// <reference path="services/DeviceGuiService.ts" />
/// <reference path="services/DeviceCredentialsService.ts" />
/// <reference path="services/FlexCollectorService.ts" />
/// <reference path="services/FlexWatchdogService.ts" />
/// <reference path="services/GatewayService.ts" />
/// <reference path="services/ConnectionRoomGroupService.ts" />
/// <reference path="services/DigiconService.ts" />

/// <reference path="services/GeocodeService.ts" />
/// <reference path="services/HealthService.ts" />
/// <reference path="services/HotspotService.ts" />
/// <reference path="services/BundleService.ts" />
/// <reference path="services/IpService.ts" />
/// <reference path="services/LinkService.ts" />
/// <reference path="services/LocationChangerService.ts" />
/// <reference path="services/LoginService.ts" />
/// <reference path="services/ManagementService.ts" />
/// <reference path="services/MessageTranslationsService.ts" />
/// <reference path="services/MiniSidebarService.ts" />
/// <reference path="services/MVPServerInfoService.ts" />
/// <reference path="services/MobileDevicesService.ts" />
/// <reference path="services/MonitoringRoomService.ts" />
/// <reference path="services/MultiBlockService.ts" />
/// <reference path="services/MVPAppScannerJobService.ts" />
/// <reference path="services/NavigationHistoryService.ts" />
/// <reference path="services/NetworkElementService.ts" />
/// <reference path="services/NetworkNodeModemService.ts" />
/// <reference path="services/NetworkNodeService.ts" />
/// <reference path="services/NetworkNodeTypeService.ts" />
/// <reference path="services/NetworkService.ts" />
/// <reference path="services/NotificationService.ts" />
/// <reference path="services/PortScannerJobService.ts" />
/// <reference path="services/PreventTemplateCacheService.ts" />
/// <reference path="services/ProbeService.ts" />
/// <reference path="services/ProfileService.ts" />
/// <reference path="services/RecordingsExportsService.ts" />
/// <reference path="services/SettingsService.ts" />
/// <reference path="services/SimPlanService.ts" />
/// <reference path="services/SIMService.ts" />
/// <reference path="services/SonAdapterService.ts" />
/// <reference path="services/StompService.ts" />
/// <reference path="services/PresetPathService.ts" />
/// <reference path="services/StreamPipeService.ts" />
/// <reference path="services/StreamStatusService.ts" />
/// <reference path="services/TimezoneService.ts" />
/// <reference path="services/TopologyElementService.ts" />
/// <reference path="services/TsProbeService.ts" />
/// <reference path="services/UserGroupService.ts" />
/// <reference path="services/UserService.ts" />
/// <reference path="services/VideoFeedService.ts" />
/// <reference path="services/VnoService.ts" />
/// <reference path="services/JsonService.ts" />

/// <reference path="directives/AlarmsDirective.ts" />
/// <reference path="directives/AlarmsLevelsDirective.ts" />
/// <reference path="directives/AutofocusDirective.ts" />
/// <reference path="directives/BlockActionsDirective.ts" />
/// <reference path="directives/ChecksDirective.ts" />
/// <reference path="directives/ColumnFilterDirective.ts" />
/// <reference path="directives/DevicePropertyDirective.ts" />
/// <reference path="directives/DocumentEventsDirective.ts" />
/// <reference path="directives/EurovisionAutoCompleteDirective.ts" />
/// <reference path="directives/EurovisionControlDirective.ts" />
/// <reference path="directives/EurovisionDatetimePickerDirective.ts" />
/// <reference path="directives/EurovisionFilterDirective.ts" />
/// <reference path="directives/EurovisionSelectDirective.ts" />
/// <reference path="directives/ErrSrcDirective.ts" />
/// <reference path="directives/EventLogDirective.ts" />
/// <reference path="directives/GridMonitorDirective.ts" />
/// <reference path="directives/GridSwitchMonitorDirective.ts" />
/// <reference path="directives/GridDigiconMonitorDirective.ts" />
/// <reference path="directives/InlineEditDirective.ts" />
/// <reference path="directives/InfiniteScrollDirective.ts" />
/// <reference path="directives/LanguageSwitcherDirective.ts" />
/// <reference path="directives/MdFabSpeedDial.ts" />
/// <reference path="directives/MdInput.ts" />
/// <reference path="directives/ModalInformationDirective.ts" />
/// <reference path="directives/MonitorDirective.ts" />
/// <reference path="directives/PipeDirective.ts" />
/// <reference path="directives/ProbeDirective.ts" />
/// <reference path="directives/SidebarPrimaryDirective.ts" />
/// <reference path="directives/SidebarPrimaryToggleDirective.ts" />
/// <reference path="directives/SidebarSecondaryDirective.ts" />
/// <reference path="directives/SidebarSecondaryToggleDirective.ts" />
/// <reference path="directives/StatusTagDirective.ts" />
/// <reference path="directives/SystemAlarmsDirective.ts" />
/// <reference path="directives/SwitchDirective.ts" />
/// <reference path="directives/VideoPlayerDirective.ts" />
/// <reference path="directives/VideoPlayerDirectiveLegacy.ts" />
/// <reference path="directives/VuMeterDirective.ts" />
/// <reference path="directives/EurovisionGraphDirective.ts" />
/// <reference path="directives/MvpDetailsTableDirective.ts" />

/// <reference path="filters/Filters.ts" />

/// <reference path="FlexPortalApp.config.ts" />
/// <reference path="FlexPortalApp.run.ts" />

namespace Application {
    'use strict';

    export namespace Controllers { }

    export namespace Directives { }

    export namespace Models { }

    export namespace Services { }

    export namespace Filters { }

    /**
     * Class representing the application
     */
    class FlexPortalApp {
        public appModule: ng.IModule;

        constructor(name: string, modules: Array<string>) {
            this.appModule = angular.module(name, modules);
        }

        public addController(name: string, controller: Function): void {
            this.appModule.controller(name, controller);
        }

        public addService(name: string, service: Function): void {
            this.appModule.service(name, service);
        }

        public addDirective(name: string, directive: ng.IDirectiveFactory): void {
            this.appModule.directive(name, directive);
        }

        public addFilter(name: string, filter: Function): void {
            this.appModule.filter(name, filter);
        }
    }

    let app: FlexPortalApp = new FlexPortalApp('flexPortalApp', ['ngRoute',
                                                                 'ngSanitize',
                                                                 'ngVis',
                                                                 'angularModalService',
                                                                 'ngCookies',
                                                                 'selectize',
                                                                 'angular.filter',
                                                                 'tableSort',
                                                                 'uiGmapgoogle-maps',
                                                                 'angular-peity',
                                                                 'ngStomp',
                                                                 'mgo-angular-wizard',
                                                                 'monospaced.mousewheel',
                                                                 'easypiechart',
                                                                 'rzModule',
                                                                 'countUpModule',
                                                                 'ngCapsLock',
                                                                 'FBAngular',
                                                                 'angular-clipboard',
                                                                 'ng.deviceDetector',
                                                                 'angular-flot',
                                                                 'angular-img-cropper',
                                                                 'chart.js',
                                                                 'ui-select'
                                                                 ]);
    app.appModule
       .config(flexPortalAppConfig)
       .run(flexPortalAppRun);

    // registering services
    let services: string[] = Object.keys(Services);
    for (let serviceClassName in services) {
        if (services.hasOwnProperty(serviceClassName)) {
            let serviceObj: RegistrableHelper = Services[services[serviceClassName]];
            if (serviceObj.hasOwnProperty("$name") && serviceObj.$name.length > 0)
                app.addService(serviceObj.$name, serviceObj);
        }
    }

    // registering controllers
    let controllers: string[] = Object.keys(Controllers);
    for (let controllerClassName in controllers) {
        if (controllers.hasOwnProperty(controllerClassName)) {
            let controllerObj: RegistrableHelper = Controllers[controllers[controllerClassName]];
            if (controllerObj.hasOwnProperty("$name") && controllerObj.$name.length > 0)
                app.addController(controllerObj.$name, controllerObj);
        }
    }

    // registering directives
    let directives: string[] = Object.keys(Directives);
    for (let directiveClassName in directives) {
        if (directives.hasOwnProperty(directiveClassName)) {
            let directiveObj: RegistrableHelper = Directives[directives[directiveClassName]];
            if (directiveObj.hasOwnProperty("$name") && directiveObj.$name.length > 0)
                app.addDirective(directiveObj.$name, directiveObj.Factory());
        }
    }

    // manually registering filters
    app.addFilter("bytesToHumanReadable", Filters.bytesToHumanReadableFilter);
    app.addFilter("bitrateToHumanReadable", Filters.bitrateToHumanReadableFilter);
    app.addFilter("remainingHumanReadableAndBadge", Filters.remainingHumanReadableAndBadge);
    app.addFilter("capitalizeFirstLetter", Filters.capitalizeFirstLetterFilter);
    app.addFilter("fromEpochToReadableDate", Filters.fromEpochToReadableDate);
    app.addFilter("secsToHHMMSS", Filters.secsToHHMMSS);
    app.addFilter("startFrom", Filters.startFromFilter);
    app.addFilter("timezone", Filters.timezoneFilter);
    app.addFilter("epochTimezone", Filters.epochTimezoneFilter);
    app.addFilter("orderObjectBy", Filters.orderObjectBy);
    app.addFilter("removeDupAlarms", Directives.removeDupAlarmsFilter);
    app.addFilter("escapeHtml", Filters.escapeHtml);
    app.addFilter("highlightMatches", Filters.highlightMatchesFilter);

    /**
     * RegistrableHelper: class helper to register services/controller/directives avoiding 'any'
     */
    class RegistrableHelper extends Function {
        public $name: string;
        public $inject: string[];
        public Factory(): ng.IDirectiveFactory { return undefined; };
    }
}
